module.exports = __webpack_public_path__ + "static/media/horse-head.29f5fea6.svg";